import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Divider, InputAdornment } from '@material-ui/core';
import Formsy from 'formsy-react';
import { bindActionCreators } from 'redux';
import { TextFieldFormsy } from '@fuse';
import * as Actions from '../../store/actions';
import { SelectSearchFormsy } from '../../../@fuse/components/formsy';
import { LocalizationConsumer } from '../../localization/LocalizationContext';
import { formatUserErrorMessage } from '../../../utils';

class CreateLabProviderForm extends Component {
    state = { canSubmit: false };

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    onSubmit = (model) => {
        const { editData, editUser, showMessage, history, addLabProvider } = { ...this.state, ...this.props };

        if (editData) {
            editUser(model, editData.id)
                .then((response) => {
                    showMessage({ message: 'Lab Provider edited successfully.' });
                    history.replace({ pathname: '/list-lab-providers' });
                })
                .catch((err) => {
                    showMessage({ message: formatUserErrorMessage(err, 'Lab Provider', 'edit') });
                });
        } else {
            addLabProvider(model)
                .then((response) => {
                    showMessage({ message: 'Lab Provider added successfully.' });
                    history.replace({ pathname: '/list-lab-providers' });
                })
                .catch((err) => {
                    showMessage({ message: formatUserErrorMessage(err, 'Lab Provider', 'add') });
                });
        }
    };

    render() {
        const { canSubmit } = this.state;
        const { processors, editData } = this.props;

        return (
            <LocalizationConsumer>
                {(localization) => (
                    <div className="min-w-3/4 max-w-3/4">
                        <Divider />

                        <Formsy
                            onValidSubmit={this.onSubmit}
                            onValid={this.enableButton}
                            onInvalid={this.disableButton}
                            /* eslint-disable-next-line no-return-assign */
                            ref={(form) => (this.form = form)}
                            className="flex flex-col justify-center"
                        >
                            <TextFieldFormsy
                                className="my-16"
                                type="text"
                                name="name"
                                label="Name"
                                value={editData ? editData.name : ''}
                                validations={{ minLength: 2 }}
                                validationErrors={{ minLength: 'Min character length is 2' }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <i className="text-20 material-icons" color="action">
                                                person
                                            </i>
                                        </InputAdornment>
                                    ),
                                }}
                                required
                                disabled={!!editData}
                                variant="outlined"
                            />

                            <TextFieldFormsy
                                className="my-16"
                                type="text"
                                name="username"
                                label="Username"
                                value={editData ? editData.username : ''}
                                validations={{ ...(!editData && { minLength: 4 }) }}
                                validationErrors={{ minLength: 'Min character length is 4' }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <i className="text-20 material-icons" color="action">
                                                bookmark
                                            </i>
                                        </InputAdornment>
                                    ),
                                }}
                                required
                                disabled={!!editData}
                                variant="outlined"
                            />

                            {!editData && (
                                <TextFieldFormsy
                                    className="my-16"
                                    type="password"
                                    name="password"
                                    label="Password"
                                    validations={{ minLength: 8, equalsField: 'password_confirmation' }}
                                    validationErrors={{ equalsField: 'Passwords do not match', minLength: 'Password must be at least 8 characters' }}
                                    InputProps={{
                                        autoComplete: 'new-password',
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <i className="text-20 material-icons" color="action">
                                                    vpn_key
                                                </i>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                    required
                                />
                            )}

                            {!editData && (
                                <TextFieldFormsy
                                    className="my-16"
                                    type="password"
                                    name="password_confirmation"
                                    label="Confirm Password"
                                    validations={{ minLength: 8, equalsField: 'password' }}
                                    validationErrors={{ equalsField: 'Passwords do not match', minLength: 'Password must be at least 8 characters' }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <i className="text-20 material-icons" color="action">
                                                    vpn_key
                                                </i>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                    required
                                />
                            )}

                            <TextFieldFormsy
                                className="my-16"
                                type="text"
                                name="email"
                                label="Email"
                                validations="isEmail"
                                validationError="This is not a valid email"
                                value={editData ? editData.email : ''}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <i className="text-20 material-icons" color="action">
                                                alternate_email
                                            </i>
                                        </InputAdornment>
                                    ),
                                }}
                                required
                                disabled={!!editData}
                                variant="outlined"
                            />

                            <Button type="submit" variant="contained" color="primary" className="mx-auto my-16" aria-label={editData ? 'EDIT LAB PROVIDER' : 'ADD LAB PROVIDER'} disabled={!canSubmit}>
                                {editData ? 'Edit Lab Provider' : 'Add Lab Provider'}
                            </Button>
                        </Formsy>
                    </div>
                )}
            </LocalizationConsumer>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            addLabProvider: Actions.addLabProvider,
            editUser: Actions.editUser,
            showMessage: Actions.showMessage,
        },
        dispatch
    );
}

export default withRouter(connect(null, mapDispatchToProps)(CreateLabProviderForm));
